//------------------------------------------------------------------------------
// This file is auto-generated.
//------------------------------------------------------------------------------
// This file was generated by NTypewriter from the C# ViewModel class with the
// same class/interface name.
//
// Do not change this file.  Any changes may cause incorrect behaviour and will
// be lost if the code is regenerated.
//------------------------------------------------------------------------------

import { ItemBase } from '../internal/ItemBase';
import { RepertoireAssignmentStatus } from './Enums';

export class RepertoireAssignmentSearchOptions extends ItemBase {
    SearchText: string | null = null;
    StudentIDs: string[] = [];
    TeacherID: string | null = null;
    RepertoireIDs: string[] = [];
    Statuses: RepertoireAssignmentStatus[] = [];
    HasActiveStudent: boolean | null = null;
    StartedDateSearchRangeStart: string | null = null;
    StartedDateSearchRangeEnd: string | null = null;
    CompletedDateSearchRangeStart: string | null = null;
    CompletedDateSearchRangeEnd: string | null = null;

    constructor(initializer?: Partial<RepertoireAssignmentSearchOptions>) {
        super();
        if (initializer) {
            Object.assign(this, initializer);
        }
    }

    static readonly ClassName: string = "RepertoireAssignmentSearchOptions";
}
